import { pushEvent } from '../googleTagManager/googleTagManagerUtils';

/**
 * Push a subscription month selection event to GTM.
 * Called when user selects which month to start their D-Ticket subscription.
 *
 * @param startDate - ISO date string (YYYY-MM-DD) for subscription start
 */
export const pushSelectSubscriptionMonthEvent = (startDate: string): void => {
	pushEvent({ event: 'selectSubscriptionMonth', startDate });
};

/**
 * Push a payment method added event to GTM.
 * Called when user successfully adds a payment method to their account.
 */
export const pushPaymentMethodAddedEvent = (): void => {
	pushEvent({ event: 'paymentMethodAdded' });
};

/**
 * Push a subscription management event to GTM.
 * Called when user pauses or resumes their subscription.
 *
 * @param type - Type of management action ('resumeSubscription' or 'pauseSubscription')
 * @param dates - Relevant dates for the action (startDate, endDate)
 */
export const pushSubscriptionManagementEvent = (
	type: 'resumeSubscription' | 'pauseSubscription',
	dates: {
		startDate?: string;
		endDate?: string;
	}
): void => {
	pushEvent({
		event: type,
		...(dates.startDate && { startDate: dates.startDate }),
		...(dates.endDate && { endDate: dates.endDate }),
	});
};
